<mat-radio-group class="menu-radio-group" (change)="onSubmit()" [(ngModel)]="typeSelection">
    <mat-radio-button class="menu-radio-button" value="label">Nur Label</mat-radio-button>
    <mat-radio-button class="menu-radio-button" value="selector">Auswählbar</mat-radio-button>
</mat-radio-group>